import { Injectable } from '@angular/core';
import { Maybe } from '@orderna/admin-panel/src/types/maybe';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import {
  Data,
  filterItems,
  getTotalItems,
} from '@orderna/admin-panel/src/utils/service';
import { BehaviorSubject, Observable } from 'rxjs';
import { fetchCategorySales } from '../../../../data/category-sales';
import { CategorySale, ICategorySale } from '../../../../model/category-sale';
import { ISalesByCategoryApiService } from './sales-by-category-api.interface';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';
import { ExportSalesByCategoryQueryDto } from './dtos/export-sales-by-category.query.dto';
import { FindSalesByCategoryQueryDto } from './dtos/find-sales-by-category.query.dto';
import { FindSalesByCategoryResponseDto } from './dtos/find-sales-by-category.response.dto';

@Injectable({
  providedIn: 'root',
})
export class SalesByCategoryMockApiService implements ISalesByCategoryApiService {
  data = {
    category_sales: {
      items: [] as CategorySale[],
      queryOptions: {
        page: 1,
        size: 10,
      } as QueryOptions<ICategorySale>,
      subject: new BehaviorSubject<Maybe<CategorySale[]>>(null),
      totalSubject: new BehaviorSubject<Maybe<number>>(null),
      totalAfterFilterSubject: new BehaviorSubject<Maybe<number>>(null),
    },
  };

  get categorySalesData() {
    return this.data['category_sales'] as Data<CategorySale, ICategorySale>;
  }

  findSalesByCategory(query: FindSalesByCategoryQueryDto): Promise<FindSalesByCategoryResponseDto> {
    throw new Error('Method not implemented.');
  }
  exportSalesByCategory(query: ExportSalesByCategoryQueryDto, options?: HandleBlobHttpResponseOptions): void {
    throw new Error('Method not implemented.');
  }
}
